import styles from './InputSelection.module.scss';

interface InputSelectionProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  type?: 'checkbox' | 'radio';
  id: string;
  label: string;
  meta?: string;
  description?: string;
  testId?: string;
}

export const InputSelection: React.FC<InputSelectionProps> = ({
  type = 'checkbox',
  id,
  label,
  meta,
  description,
  testId,
  ...props
}) => (
  <div className={styles.wrapper}>
    <input
      type={type}
      id={id}
      data-testid={testId}
      {...props}
      className={styles.input}
      aria-describedby={description ? `${id}-description` : undefined}
    />
    <label
      htmlFor={id}
      className={styles.label}
      data-testid={testId ? `${testId}-label` : undefined}
    >
      <span className={styles.labelContent}>
        {label}
        {meta && <span className={styles.meta}>{meta}</span>}
        {description && (
          <p className={styles.description} id={`${id}-description`}>
            {description}
          </p>
        )}
      </span>
    </label>
  </div>
);
